var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("Navbar"),
      _c("div", { staticClass: "step-page" }, [
        _c(
          "section",
          { staticClass: "section-04" },
          [
            _vm._m(0),
            _c(
              "div",
              { staticClass: "job-list" },
              [
                _c(
                  "div",
                  {
                    staticClass: "row",
                    staticStyle: { "margin-bottom": "15px" },
                  },
                  [
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "from-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.searchCondition.ManpowerDemandName,
                              expression: "searchCondition.ManpowerDemandName",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", placeholder: "請輸入關鍵字" },
                          domProps: {
                            value: _vm.searchCondition.ManpowerDemandName,
                          },
                          on: {
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              $event.stopPropagation()
                              $event.preventDefault()
                              ;(_vm.searchCondition.ManpowerDemandNo = null),
                                _vm.getJobOpening()
                            },
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.searchCondition,
                                "ManpowerDemandName",
                                $event.target.value.trim()
                              )
                            },
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c(
                        "div",
                        { staticClass: "from-group" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "w-100",
                              attrs: {
                                filterable: true,
                                clearable: "",
                                placeholder: "地點不拘",
                              },
                              model: {
                                value: _vm.searchCondition.Workplace,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchCondition,
                                    "Workplace",
                                    $$v
                                  )
                                },
                                expression: "searchCondition.Workplace",
                              },
                            },
                            _vm._l(_vm.workplaceOptions, function (workplace) {
                              return _c("el-option", {
                                key: workplace.Guid,
                                attrs: {
                                  label: workplace.WorkPlaceName,
                                  value: workplace.WorkPlaceName,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("div", { staticClass: "from-group" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm",
                            on: {
                              click: function ($event) {
                                ;(_vm.searchCondition.ManpowerDemandNo = null),
                                  _vm.getJobOpening()
                              },
                            },
                          },
                          [
                            _c("eva-icon", {
                              attrs: { name: "search-outline", fill: "#fff" },
                            }),
                            _vm._v(" 查詢 "),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]
                ),
                _vm._l(_vm.jobOpeningList, function (job) {
                  return _c("div", { key: job.No, staticClass: "job" }, [
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        {
                          staticClass: "name",
                          on: {
                            click: function ($event) {
                              return _vm.openJobDescriptionModal(job)
                            },
                          },
                        },
                        [
                          _vm._v(" " + _vm._s(job.ManpowerDemandName) + " "),
                          _c("eva-icon", {
                            attrs: {
                              name: "question-mark-circle",
                              fill: "red",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "tag" },
                        [
                          _vm._l(job.WorkPlace, function (place) {
                            return _c("span", { key: place }, [
                              _vm._v(_vm._s(place)),
                            ])
                          }),
                          job.WorkExperienceWhatever
                            ? _c("span", [_vm._v("工作經驗不拘")])
                            : _c("span", [
                                _vm._v(_vm._s(job.WorkExperience) + " 年"),
                              ]),
                          job.EducationDemandWhatever
                            ? _c("span", [_vm._v("學歷不拘")])
                            : _vm._l(
                                job.EducationDemand,
                                function (education, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(" " + _vm._s(education) + " "),
                                  ])
                                }
                              ),
                        ],
                        2
                      ),
                      _c("div", { staticClass: "desc" }, [
                        _c("pre", { staticStyle: { "font-size": "14px" } }, [
                          _vm._v(_vm._s(job.WorkContent)),
                        ]),
                      ]),
                    ]),
                    _c("div", { staticClass: "edit" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn",
                          attrs: { type: "btn" },
                          on: {
                            click: function ($event) {
                              return _vm.getDemandInfo(job)
                            },
                          },
                        },
                        [_vm._v(" 我要應徵 ")]
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
            _vm.totalData > 0
              ? _c("el-pagination", {
                  staticClass: "mb-3",
                  staticStyle: { "text-align": "center" },
                  attrs: {
                    background: "",
                    layout: "prev, pager, next",
                    "page-size": 10,
                    total: _vm.totalData,
                  },
                  on: { "current-change": _vm.changePage },
                })
              : _c(
                  "p",
                  {
                    staticClass: "mt-4 text-center",
                    staticStyle: { color: "#fff" },
                  },
                  [_vm._v("尚無資料")]
                ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "applyModal",
              tabindex: "-1",
              "aria-labelledby": "jobModal",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
              _c("div", { staticClass: "modal-content" }, [
                _vm._m(1),
                _c("div", { staticClass: "modal-body" }, [
                  _c("p", [_vm._v("應徵職務：" + _vm._s(_vm.PositionName))]),
                  _c("span", [_vm._v("填寫履歷：")]),
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          _vm.ResumeType === "IDL"
                            ? `${_vm.url}/#/candidate/idl`
                            : `${_vm.url}/#/candidate/dl`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.ResumeType === "IDL" ? "IDL 履歷" : "DL 履歷"
                          ) +
                          "(確認應徵前，請完成履歷填寫) "
                      ),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-secondary",
                      attrs: { type: "button", "data-dismiss": "modal" },
                    },
                    [_vm._v(" 取消 ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "submit" },
                      on: { click: _vm.apply },
                    },
                    [_vm._v(" 確認 ")]
                  ),
                ]),
              ]),
            ]),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "modal fade",
            attrs: {
              id: "jobModal",
              tabindex: "-1",
              "aria-labelledby": "jobModal",
              "aria-hidden": "true",
            },
          },
          [
            _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("span", { staticClass: "modal-title" }, [
                    _vm._v(
                      " " + _vm._s(_vm.job.ManpowerDemandName) + "-職務說明 "
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "modal-body" }, [
                  _vm.job.PositionInstruction === null
                    ? _c("span", [_vm._v("尚無說明")])
                    : _c("pre", [_vm._v(_vm._s(_vm.job.PositionInstruction))]),
                ]),
              ]),
            ]),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("職缺列表")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("span", { staticClass: "modal-title" }, [_vm._v("確認應徵")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }